function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M7.71 15.76a1.15 1.15 0 0 0-1.63 0 1.17 1.17 0 0 0 0 1.63l5.74 5.73a1.15 1.15 0 0 0 1.63 0L26.07 10.5a1.15 1.15 0 0 0-1.62-1.62L12.63 20.69z",
  "data-name": "Complete"
});

var SvgComponent = function SvgComponent(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), React.createElement("title", null, title), _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+CiAgPHRpdGxlPkNvbnRhY3QgQ29tcGxldGU8L3RpdGxlPgogIDxnIGlkPSIzMWQ3ZjkxMC01OGFmLTRjZTYtODg4Zi1mNjZkZTMzZmNjMjgiIGRhdGEtbmFtZT0iQ29tcGxldGUiPgogICAgPHBhdGggZmlsbD0nI2ZmZmZmZicgZD0iTTcuNzEsMTUuNzZhMS4xNSwxLjE1LDAsMCwwLTEuNjMsMCwxLjE3LDEuMTcsMCwwLDAsMCwxLjYzbDUuNzQsNS43M2ExLjE1LDEuMTUsMCwwLDAsMS42MywwTDI2LjA3LDEwLjVhMS4xNSwxLjE1LDAsMCwwLTEuNjItMS42MkwxMi42MywyMC42OVoiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgComponent as ReactComponent };